<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <section class="list">
        <h3>
          絞り込み条件
          <div class="ctrl-btn opened" @click="switchAccordion"></div>
        </h3>
        <div class="accordion_inner">
          <v-row>
            <v-col cols="3">
              <v-menu
                v-model="from_dialog"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="開始"
                    v-model="filterKeyword.from"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="filterKeyword.from" @input="from_dialog = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-menu
                v-model="to_dialog"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="to"
                    label="終了"
                    v-model="filterKeyword.to"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="filterKeyword.to" @input="to_dialog = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </div>
        <h3 class="mt-5">検索結果</h3>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          :loading="loading">
            <template v-slot:item.createdAt="{ item }">
              {{ getDateTime(item.createdAt) }}
            </template>
            <template v-slot:item.userID="{ item }">
              {{ users[item.userID] }}
            </template>
            <template v-slot:item.customerID="{ item }">
              {{ customers[item.customerID] }}
            </template>
        </v-data-table>
      </section>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { listLogs, listCustomers, listUsers } from '../graphql/queries'
import { onCreateLog } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '日時', align: 'start', value: 'createdAt', sortable: false },
        { text: 'ユーザー', align: 'start', value: 'userID', sortable: false },
        { text: '客先', align: 'start', value: 'customerID', sortable: false },
        { text: '種別', align: 'start', value: 'type', sortable: false },
        { text: '操作', align: 'start', value: 'text', sortable: false },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      customers: {},
      users: {},
      filterKeyword: {},
      from_dialog: false,
      to_dialog: false,
    }
  },
  prop: {},
  mounted: async function() {
    //客先 query
    await this.getCustomers()
    //ユーザー query
    await this.getUsers()
    //ログ query
    await this.getLogs()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateLog)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateLog
        this.desserts.push(row)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //開始
        if (this.filterKeyword.from && moment(this.filterKeyword.from) > moment(item.createdAt)) continue
        //終了
        if (this.filterKeyword.to && moment(this.filterKeyword.to + 'T23:59:59') < moment(item.createdAt)) continue
        map.push(item)
      }
      return map
    },
  },
  watch: {

  },
  methods: {
    //初期化
    async init() {

    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //ログの取得
    async getLogs(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listLogs, { limit: 500, nextToken: nextToken }))
      for (const row of query.data.listLogs.items) {
        this.desserts.push(row)
      }
      if (query.data.listLogs.nextToken) this.getLogs(query.data.listLogs.nextToken)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers[data.id] = data.name
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users[data.id] = data.last + data.first
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
  },
  components: {

  },
}
</script>

<style lang='scss' scoped>
.list {
  h3 {
    position: relative;
    .ctrl-btn {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      font-size: 20px;
      &:after {
        content: "\f139";
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
      }
      &.opened:after {
        content: "\f13a";
      }
    }
  }
  .total {
    text-align: right;
    font-size: 20px;
    .label {
      padding: 10px;
    }
    .value {
      display: inline-block;
      background: #EEE;
      padding: 10px;
      width: 200px;
    }
  }
}
.print-sheet {
  h2 {
    font-size: 24px;
    padding: 15px 10px;
    background: #EEE;
    text-align: center;
  }
  .customer-name {
    font-size: 18px;
    margin: 15px 0;
    padding: 5px 0;
    border-bottom: 1px solid #CCC;
    span {
      float: right;
    }
  }
  .amount {
    text-align: right;
    margin-top: 30px;
    font-size: 20px;
    padding-left: 200px;
    position: relative;
    padding: 10px 0;
    border-bottom: 3px double #CCC;
    .label {
      position: absolute;
      left: 0;
    }
  }
  .label-box {
    position: relative;
    width: 320px;
    margin-left: auto;
    margin-right: 0;
    text-align: right;
    padding: 5px 0;
    border-bottom: 1px solid #CCC;
    .label {
      position: absolute;
      left: 0;
    }
  }
  .company-info {
    position: relative;
    width: 320px;
    margin-left: auto;
    margin-right: 0;
    margin-top: 20px;
    background: #eee;
    padding: 10px;
    .company-name {
      font-size: 20px;
      font-weight: bold;
    }
    .company-post {
      margin-top: 10px;
    }
  }
  .product-name {
    li {

      &:after {
        content: "/";
        margin: 0 10px;
      }
      &:last-of-type:after {
        content: "";
        margin: 0;
      }
    }
  }
  .total {
    > div {
      padding: 5px 16px;
      text-align: right;
      font-size: 120%;
      width: 330px;
      margin-right: 0;
      margin-left: auto;
      .label {
        font-weight: bold;
      }
      .value {
        display: inline-block;
        width: 200px;
      }
    }
  }
}
</style>
